import styled from 'styled-components';
import TrainedStaffSvg from '../../../assets/onboardingNew/homepage/trained-staff.svg';

const TrainedStaffNewIcon = styled(TrainedStaffSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2.8rem'};
height: ${props => props.height || '3.2rem'};
display: flex;
`;

export default TrainedStaffNewIcon;
